<mat-nav-list class="menu" (mouseenter)="isShowing = true" (mouseleave)="isShowing = false">

    <mat-list-item routerLink="/dashboard" routerLinkActive #rla1="routerLinkActive" [activated]="rla1.isActive">
        <mat-icon mat-list-icon>dashboard</mat-icon>
        @if (isExpanded || isShowing) {
        <span class="full-width">Dashboard</span>
        }
    </mat-list-item>

    <mat-divider class="divider"></mat-divider>

    @if (!organizationsService.isCurrentOrganizationPartner()
    && !organizationsService.isCurrentOrganizationClient()) {

    <mat-list-item routerLink="/organizations" routerLinkActive #rlaOrga="routerLinkActive"
        [activated]="rlaOrga.isActive">
        <mat-icon mat-list-icon>business</mat-icon>
        @if (isExpanded || isShowing) {
        <span class="full-width">Partenaires</span>
        }
    </mat-list-item>
    }

    @if (!organizationsService.isCurrentOrganizationClient()) {
    <mat-list-item routerLink="/clients" routerLinkActive #rlaClients="routerLinkActive"
        [activated]="rlaClients.isActive">
        <mat-icon mat-list-icon>groups</mat-icon>
        @if (isExpanded || isShowing) {
        <span class="full-width">Clients</span>
        }
    </mat-list-item>
    }

    @if (access.canAccess(NexusModule.Administrateur)) {
    <mat-list-item routerLink="/admin" routerLinkActive #rlaAdmins="routerLinkActive" [activated]="rlaAdmins.isActive">
        <mat-icon mat-list-icon>security</mat-icon>
        @if (isExpanded || isShowing) {
        <span class="full-width">Administrateurs</span>
        }
    </mat-list-item>
    }

    @if (access.canAccess(NexusModule.Administrateur)) {
    <mat-list-item routerLink="/users" routerLinkActive #rlaUsers="routerLinkActive" [activated]="rlaUsers.isActive">
        <mat-icon mat-list-icon>account_circle</mat-icon>
        @if (isExpanded || isShowing) {
        <span class="full-width">Utilisateurs</span>
        }
    </mat-list-item>
    }

    <mat-divider class="divider"></mat-divider>

    @if (access.canAccess(NexusModule.Centrex)) {
    <mat-list-item routerLink="/services" routerLinkActive #rlaServices="routerLinkActive"
        [activated]="rlaServices.isActive">
        <mat-icon mat-list-icon>grid_on</mat-icon>
        @if (isExpanded || isShowing) {
        <span class="full-width">Services</span>
        }
    </mat-list-item>
    }

    <!-- @if (access.canAccess(NexusModule.Commande)) {
    <mat-list-item
      routerLink="/ticketing"
      routerLinkActive
      #rlaTickets="routerLinkActive"
      [activated]="rlaTickets.isActive">
      <mat-icon mat-list-icon>confirmation_number</mat-icon>
      @if (isExpanded || isShowing) {
        <span class="full-width">Ticketing</span>
      }
    </mat-list-item>
  } -->

</mat-nav-list>